/**
 * URL-param parsing — mirrors
 *   packages/amgroulette_v2/lib/core/utils/url_params.dart
 */
import { DEFAULT_AGENT_ID, DEFAULT_USER_NAME, GAME_KEY_MULTI } from '../config';

export interface UrlParams {
  token: string | null;
  gsid: string | null;
  userName: string;
  agentId: string;
  isSound: boolean;
  exitUrl: string | null;
  /** Raw game key from the `g` query param (e.g. 'RLA1', 'RLAM'); null if absent. */
  gameKey: string | null;
  /**
   * Resolved game mode, derived from how the lobby launches the game:
   *   - single: `/?g=RLA1`            (g = GAME_KEY_SINGLE)
   *   - multi:  `/roulettehub?g=RLAM` (g = GAME_KEY_MULTI)
   * Either signal (the `g` key or the `/roulettehub` path) flags multi;
   * everything else defaults to single. Replaces the launch-time mode dialog.
   */
  gameMode: 'single' | 'multi';
}

export function loadUrlParams(): UrlParams {
  const q = new URLSearchParams(window.location.search);
  const gameKey = q.get('g');
  return {
    token: q.get('token'),
    gsid: q.get('gsid'),
    userName: q.get('user') ?? q.get('userName') ?? DEFAULT_USER_NAME,
    agentId: q.get('agentId') ?? DEFAULT_AGENT_ID,
    isSound: q.get('isSound') === 'true' || q.get('isSound') === '1',
    exitUrl: q.get('exitUrl'),
    gameKey,
    gameMode: resolveGameMode(gameKey, window.location.pathname),
  };
}

/**
 * Resolve single vs multi from the lobby launch URL. The lobby routes
 * multiplayer to `/roulettehub?g=RLAM` and single-player to `/?g=RLA1`,
 * so either the `g` game key or the path is enough to flag multiplayer.
 */
function resolveGameMode(
  gameKey: string | null,
  pathname: string,
): 'single' | 'multi' {
  const isMulti =
    gameKey === GAME_KEY_MULTI || /roulettehub/i.test(pathname);
  return isMulti ? 'multi' : 'single';
}
